<template lang="pug">
    section#ingressar2
        div.wrapper
            h2
                |Como Ingressar:
                br
                |NÃO PRECISA DE VESTIBULAR!
            span
                |Você ingressa a partir da análise dos seguintes documentos:
            ul
                li
                    |Programas das disciplinas cursadas com aprovação, devidamente assinados pelo Serviço de Graduação da Unidade de origem;
                li
                    |Histórico escolar de graduação devidamente assinados pelo Serviço de Graduação da Instituição de Ensino Superior de origem;
                li
                    |Diploma de graduação – quando o candidato já tiver um curso concluído.
            p
                |Assim você poderá aproveitar todos os benefícios de estudar na UniFAEL, incluindo concorrer
                br
                span BOLSAS DE ESTUDOS
                |de até
                span 45%
                |em seu Polo de inscrição.
</template>

<script>
export default {
    name: "section-ingressar-2"
}
</script>

<style lang="stylus" scoped src="./Ingressar2.styl"></style>
